module.exports = __webpack_public_path__ + "res/ic_coin.69a36865b3e04c04a80eb9808a2c4a9f.png";